import { render, staticRenderFns } from "./PopOrderWuliuList.vue?vue&type=template&id=e64d40a2&scoped=true&"
import script from "./PopOrderWuliuList.vue?vue&type=script&lang=js&"
export * from "./PopOrderWuliuList.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderWuliuList.vue?vue&type=style&index=0&id=e64d40a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64d40a2",
  null
  
)

export default component.exports